import {invokeApig} from "../../libs/awsLib";
import {getUserApiData} from "../../utils/UserUtils";
import Paths from "../paths";

/**
 * Rozkład kolumny poziomu grupowania i podgląd grup roboczej konfiguracji - tylko dla modala poziomu
 * (tabela dalej używa getGroupedData / getPaginatedData).
 * @param {Object} body
 * @param {string} body.ResultID
 * @param {Array} [body.Filter] ten sam format co w getPaginatedData
 * @param {Array} body.GroupFields cała struktura; `GroupFields[Level]` to wersja robocza z modala
 * @param {number} body.Level edytowany poziom (od 0)
 * @param {*} [body.ParentKey] klucz grupy poziomu wyżej (Level >= 1) - zawęża do jednej grupy
 * @param {{by?: string, direction?: string, customSort?: string}} [body.GroupSort] tryb "Każda wartość"
 * @param {Array<"profile"|"preview">} body.Include profile - wykres i propozycje, preview - grupy konfiguracji
 * @param {Object} [user] FarmID, ClientID, LocalUserID
 * @param {AbortSignal} [signal] anulowanie przy kolejnym zapytaniu
 */
export function getGroupDistribution(
    {ResultID, Filter, GroupFields, Level, ParentKey, GroupSort, Include},
    {FarmID, ClientID, LocalUserID} = {},
    signal
) {
    const {_FarmID, _LocalUserID, _ClientID} = getUserApiData({
        FarmID,
        ClientID,
        LocalUserID,
    });
    return invokeApig({
        ...Paths.getGroupDistribution({
            farmID: _FarmID,
            clientID: _ClientID,
            localUserID: _LocalUserID,
        }),
        body: {
            ResultID,
            Filter,
            GroupFields,
            Level,
            ParentKey,
            GroupSort,
            Include,
        },
        signal,
    });
}
